module.exports = __webpack_public_path__ + "img/m1-screenshot-03.473f8c96.png";